import { render, staticRenderFns } from "./AppListPage.vue?vue&type=template&id=a22c4370"
import script from "./AppListPage.vue?vue&type=script&lang=js"
export * from "./AppListPage.vue?vue&type=script&lang=js"
import style0 from "./AppListPage.vue?vue&type=style&index=0&id=a22c4370&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports